import _ from "@lodash";
import * as Helpers from "app/Core/Helpers";
import XAPPService from "app/Core/services/XAPPService";
import { addAgendamentoTemporario } from "app/CRM/Agendamento/Store/Actions/AgendamentoActions";
import dayjs from "dayjs";
export const GET_AGENDAMENTOEDICAO = "[AGENDAMENTOEDICAO APP] GET AGENDAMENTOEDICAO";
export const AGENDAMENTOEDICAO_ERROR = "[AGENDAMENTOEDICAO APP] AGENDAMENTOEDICAO ERROR";
export const AGENDAMENTOEDICAO_WARNING = "[AGENDAMENTOEDICAO APP] AGENDAMENTOEDICAO WARNING";
export const AGENDAMENTOEDICAO_INFO = "[AGENDAMENTOEDICAO APP] AGENDAMENTOEDICAO INFO";
export const GET_PESSOASPRODUTOSEMPRESA = "[AGENDAMENTOEDICAO APP] GET PESSOA SERVICO EMPRESA";
export const GET_LOCAISEMPRESA = "[AGENDAMENTOEDICAO APP] GET LOCAIS EMPRESA";
export const GET_HORARIOAGENDADO = "[AGENDAMENTOEDICAO APP] GET HORARIO DISPONIVEL";
export const GET_DADOSRESPONSAVEL = "[AGENDAMENTOEDICAO APP] GET DADOS RESPONSAVEIS";

const AgendamentoGet = [
    "idagendamento",
    "responsaveis",
    "clientes",
    "status",
    "fontepagadora",
    "idpessoaformulariolocal",
    "titulo",
    "anotacoes",
    "tipo",
    "inicio",
    "iniciodescricao",
    "termino",
    "terminodescricao",
    "agendamentotag",
    "preatendimento",
];

const EmpresaLocalGet = [
    "idpessoaformulario",
    "nome",
    "endereco",
    "fone"
];

const EmpresaPessoaProdutoGet = [
    "idpessoaformulario",
    "nome",
    "idproduto",
    "produtonome",
    "qtdprofissionais",
    "produtonomevalor",
    "produtoformulario",
    "produtovalor",
    "produtovalordescricao",
    "tipo",
    "tipodescricao"
];

const HorarioAgendadoGet = [
    "idagendamento",
    "idpessoaformulario",
    "nome",
    "tipo",
    "inicio",
    "duracao",
    "selected",
    "idpessoaformulariolocal",
    "dados"
];

const DadosResponsavelGet = [
    "idpessoaformulario",
    "nome",
    "celular",
    "email",
    "webex",
    "fone",
    "formulario",
    "configuracao"
];

export function get(_AID = null, _AParams) {

    return (dispatch) => {
        if (_.isNull(_AID)) {
            return null;
        }
        var AConditionsAND = [{ "Campo": "agendamento.idagendamento", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Agendamento", AActions, "spvwagendamento", AgendamentoGet, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                if (JSON.parse(response.data)[0].data !== null) {
                    Promise.all([
                        dispatch({
                            type: GET_AGENDAMENTOEDICAO,
                            name: _AID,
                            payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                        })
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: AGENDAMENTOEDICAO_ERROR,
                    payload: error
                });
            });
    };
}

export function getBaseFiltro(_AParams) {

    return (dispatch) => {
        var AActions = [];
        var AConditionsOR = [];
        var AConditionsAND = [{ "Campo": "pessoaformulario.statusregistro", "Operador": "=", "Valor": 1 }];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "LocaisEmpresa", AActions, "spvwempresalocal", EmpresaLocalGet, "SELECIONAR", AConditionsAND, AConditionsOR);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "PessoasProdutosEmpresa", AActions, "spvwempresapessoaprodutolookup", EmpresaPessoaProdutoGet, "SELECIONAR", [], AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_LOCAISEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_PESSOASPRODUTOSEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: AGENDAMENTOEDICAO_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch, getState) => {

        let AConfig = _.find(getState().auth.user.data.settings.sistemas[_AParams.empresa].dados.configuracao, { "chave": "AGENDAMENTO_SIMULTANEO" });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        let ATmpValue = Object.assign({}, _AValue);
        if (!_.isUndefined(_AValue.status) && !_.isNull(_AValue.status)) {
            ATmpValue.status = _AValue.status.id;
        }

        if (!_.isUndefined(_AValue.data) && !_.isNull(_AValue.data)) {
            ATmpValue.inicio = _AValue.data + " " + _AValue.inicio;
            ATmpValue.termino = _AValue.data + " " + _AValue.termino;
        }

        ATmpValue.clientesLookup = null;
        ATmpValue.responsaveisLookup = null;

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", _AAction, ATmpValue, "", AConditionsAND, AConditionsOR, 1, null, { "agendamento-simultaneo": AConfig?.valor });

        if (_AAction === "ALTERARSTATUS") {
            let AAction = "";
            if (_AValue.status.iniciarprocesso && _.isNull(_AValue.idtarefaprocesso)) {
                AAction = "INICIARFLUXO";
            }
            if (_AValue.status.cancelarprocesso && !_.isNull(_AValue.idtarefaprocesso)) {
                AAction = "CANCELARFLUXO";
            }
            if (AAction.length > 1) {
                AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", AAction, ATmpValue, "", AConditionsAND, AConditionsOR);
            }
        }

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionagendamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    dispatch({
                        type: AGENDAMENTOEDICAO_WARNING,
                        payload: response.warning
                    });
                }
                else if (response.info) {
                    dispatch({
                        type: AGENDAMENTOEDICAO_INFO,
                        payload: response.info,
                        id: response.ultimoidinserido
                    });

                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }

                    if (!_.isUndefined(_AValue.idagendamento) && !_.isNull(_AValue.idagendamento)) {
                        dispatch(get(_AValue.idagendamento, _AParams));
                    }

                    if (_AValue.preatendimento?.videoChamada && _.isNull(_AValue.idagendamento) && !_.isNull(response.ultimoidinserido)) {
                        dispatch(addAgendamentoTemporario({
                            ..._AValue,
                            idagendamento: response.ultimoidinserido,
                            agendamentotag: null,
                            temporario: true,
                        }));
                        dispatch(get(response.ultimoidinserido, _AParams));
                    }
                }
            }
            ).catch(error => {
                return dispatch({
                    type: AGENDAMENTOEDICAO_ERROR,
                    payload: error
                });
            });
    };
}

export function getHorarioAgendado(_AParams, _AFiltros, _AIDAgendamento, _AStep) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "step_agendamento", "Operador": "=", "Valor": _AStep }];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFiltros.tipo) {
            AConditionsAND.push({ "Campo": "tipo", "Operador": "=", "Valor": _AFiltros.tipo });
        }

        if (_AFiltros.inicio) {
            AConditionsAND.push({ "Campo": "inicio", "Operador": "=", "Valor": dayjs(_AFiltros.inicio).format("YYYY-MM-DD") });
            AConditionsAND.push({ "Campo": "termino", "Operador": "=", "Valor": dayjs(_AFiltros.inicio).format("YYYY-MM-DD") });
        }

        if (_AFiltros.responsaveis) {
            AConditionsAND.push({ "Campo": "responsaveis", "Operador": "=", "Valor": Helpers.ReplaceAll(Helpers.ReplaceAll(_AFiltros.responsaveis.join(), "[", "{"), "]", "}") });
        }

        if (_AFiltros.idagendamento) {
            AConditionsAND.push({ "Campo": "idagendamento", "Operador": "=", "Valor": _AFiltros.idagendamento });
        }

        if (_AFiltros.allResponsaveis) {
            AConditionsAND.push({ "Campo": "allResponsaveis", "Operador": "=", "Valor": _AFiltros.allResponsaveis });
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "HorarioAgendado", AActions, "spvwhorarioagendado", HorarioAgendadoGet, "SELECIONAR", AConditionsAND, AConditionsOR);

        AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "IN", "Valor": "(" + Helpers.ReplaceAll(Helpers.ReplaceAll(_AFiltros.responsaveis.join(), "[", ""), "]", "") + ")" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "DadosResponsavel", AActions, "spvwempresapessoafuncionarioatendimento", DadosResponsavelGet, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_HORARIOAGENDADO,
                        Name: _AIDAgendamento,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_DADOSRESPONSAVEL,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ]);
            }).catch(error => {
                return dispatch({
                    type: AGENDAMENTOEDICAO_ERROR,
                    payload: error
                });
            });
    };
}

export function openDialog(_AName, _AValue = null) {
    return {
        type: GET_AGENDAMENTOEDICAO,
        payload: _AValue,
        name: _AName
    };
}

export function saveAgendamentoPessoa(_AValue, _AParams) {

    var AListUpdate = [
        "observacao"
    ];

    return (dispatch) => {
        var AConditionsAND = [{ Campo: "agendamentopessoaformulario.idagendamentopessoaformulario", Operador: "=", Valor: _AValue.idagendamentopessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "agendamentopessoaformulario", "ATUALIZAR", _AValue, "", AConditionsAND, AConditionsOR, 1, AListUpdate);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: AGENDAMENTOEDICAO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isUndefined(_AValue.idagendamento) && !_.isNull(_AValue.idagendamento)) {
                            dispatch(get(_AValue.idagendamento, _AParams));
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: AGENDAMENTOEDICAO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        }),
                    ]).then(() => {
                        if (!_.isUndefined(_AValue.idagendamento) && !_.isNull(_AValue.idagendamento)) {
                            dispatch(get(_AValue.idagendamento, _AParams));
                        }
                    });
                }
            }
            ).catch(error => {
                return dispatch({
                    type: AGENDAMENTOEDICAO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return (dispatch) => {
        Promise.all([
            dispatch({
                type: GET_AGENDAMENTOEDICAO,
                payload: null
            }),
            dispatch({
                type: GET_DADOSRESPONSAVEL,
                payload: null
            }),
            dispatch({
                type: GET_HORARIOAGENDADO,
                payload: null
            })
        ]);
    };
}